import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import Home from '../pages/Home';
import Login from '../pages/Login';
import ResetPassword from '../pages/ResetPassword';
import Brochures from '../pages/Brochures';
import BrochuresHBO from '../pages/BrochuresHBO';
import BrochuresMaster from '../pages/BrochuresMaster';
import BrochuresMasterclasses from '../pages/BrochuresMasterclasses';
import Studiefinanciering from '../pages/Studiefinanciering';
import OverNLBA from '../pages/OverNLBA';
import OverNLBAWaarom from '../pages/OverNLBAWaarom';
import OverNLBAAccreditatie from '../pages/OverNLBAAccreditatie';
import OverNLBATeam from '../pages/OverNLBATeam';
import OverNLBAReviews from '../pages/OverNLBAReviews';
import OverNLBAOrganogram from '../pages/OverNLBAOrganogram';
import News from '../pages/News';
import Contact from '../pages/Contact';
import RegistrationForm from '../pages/RegistrationForm';

// Student pages
import StudentLayout from '../pages/student/StudentLayout';
import StudentDashboard from '../pages/student/Dashboard';
import MyCourses from '../pages/student/MyCourses';
import StudentCalendar from '../pages/student/Calendar';
import Grades from '../pages/student/Grades';
import Homework from '../pages/student/Homework';
import Payments from '../pages/student/Payments';
import Report from '../pages/student/Report';
import Exams from '../pages/student/Exams';
import StudentNotifications from '../pages/student/Notifications';
import StudentDeclarations from '../pages/student/Declarations';
import StudentModuleEvaluations from '../pages/student/ModuleEvaluations';
import StudentProfile from '../pages/student/Profile';

// Admin pages
import AdminLayout from '../pages/admin/AdminLayout';
import AdminDashboard from '../pages/admin/Dashboard';
import AdminStudies from '../pages/admin/Studies';
import AdminStudyRegistrations from '../pages/admin/StudyRegistrations';
import AdminEnrollments from '../pages/admin/Enrollments';
import AdminCalendar from '../pages/admin/Calendar';
import AdminPayments from '../pages/admin/Payments';
import AdminUsers from '../pages/admin/Users';
import AdminCohorts from '../pages/admin/Cohorts';
import AdminDepartments from '../pages/admin/Departments';
import AdminHomework from '../pages/admin/Homework';
import AdminBlogs from '../pages/admin/Blogs';
import AdminBrochures from '../pages/admin/Brochures';
import AdminNotifications from '../pages/admin/Notifications';
import AdminDeclarations from '../pages/admin/Declarations';
import AdminContentManager from '../pages/admin/ContentManager';
import AdminModuleMaterials from '../pages/admin/ModuleMaterials';
import AdminModuleEvaluations from '../pages/admin/ModuleEvaluations';
import AdminExamComponentUploads from '../pages/admin/ExamComponentUploads';
import ReportPayments from '../pages/admin/ReportPayments';
import ReportGrades from '../pages/admin/ReportGrades';
import AnnualGradeList from '../pages/admin/AnnualGradeList';

const AppRoutes = () => {
  const withRoles = (roles, element) => (
    <ProtectedRoute allowedRoles={roles}>{element}</ProtectedRoute>
  );

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<Navigate to="/over-nlba" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/brochures" element={<Navigate to="/brochures/hbo" replace />} />
      <Route path="/brochures/all" element={<Brochures />} />
      <Route path="/brochures/hbo" element={<BrochuresHBO />} />
      <Route path="/brochures/master" element={<BrochuresMaster />} />
      <Route path="/brochures/masterclasses" element={<BrochuresMasterclasses />} />
      <Route path="/studiefinanciering" element={<Studiefinanciering />} />
      <Route path="/over-nlba" element={<OverNLBA />} />
      <Route path="/over-nlba/waarom-kies-je-voor-ons" element={<OverNLBAWaarom />} />
      <Route path="/over-nlba/accreditatie" element={<OverNLBAAccreditatie />} />
      <Route path="/over-nlba/ons-team" element={<OverNLBATeam />} />
      <Route path="/over-nlba/reviews" element={<OverNLBAReviews />} />
      <Route path="/over-nlba/organogram" element={<OverNLBAOrganogram />} />
      <Route path="/news" element={<News />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/inschrijven" element={<RegistrationForm />} />

      {/* Student Portal Routes */}
      <Route
        path="/student/*"
        element={
          <ProtectedRoute allowedRoles={['student']}>
            <StudentLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<StudentDashboard />} />
        <Route path="courses" element={<MyCourses />} />
        <Route path="calendar" element={<StudentCalendar />} />
        <Route path="grades" element={<Grades />} />
        <Route path="homework" element={<Homework />} />
        <Route path="payments" element={<Payments />} />
        <Route path="report" element={<Report />} />
        <Route path="exams" element={<Exams />} />
        <Route path="notifications" element={<StudentNotifications />} />
        <Route path="declarations" element={<StudentDeclarations />} />
        <Route path="module-evaluations" element={<StudentModuleEvaluations />} />
        <Route path="profile" element={<StudentProfile />} />
      </Route>

      {/* Admin Portal Routes */}
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute allowedRoles={['admin', 'manager', 'instructor']}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={withRoles(['admin', 'manager', 'instructor'], <AdminDashboard />)} />
        <Route path="studies" element={withRoles(['admin', 'manager'], <AdminStudies />)} />
        <Route path="study-registrations" element={withRoles(['admin', 'manager'], <AdminStudyRegistrations />)} />
        <Route path="course-assignments" element={withRoles(['admin', 'manager'], <AdminEnrollments />)} />
        <Route path="enrollments" element={<Navigate to="/admin/course-assignments" replace />} />
        <Route path="calendar" element={withRoles(['admin', 'manager', 'instructor'], <AdminCalendar />)} />
        <Route path="reports" element={<Navigate to="/admin/report-payments" replace />} />
        <Route path="report-payments" element={withRoles(['admin', 'manager'], <ReportPayments />)} />
        <Route path="grades-entry" element={withRoles(['admin', 'manager', 'instructor'], <ReportGrades />)} />
        <Route path="report-grades" element={withRoles(['admin', 'manager', 'instructor'], <ReportGrades />)} />
        <Route path="annual-grade-list" element={withRoles(['admin', 'manager', 'instructor'], <AnnualGradeList />)} />
        <Route path="homework" element={withRoles(['admin', 'manager', 'instructor'], <AdminHomework />)} />
        <Route path="payments" element={withRoles(['admin', 'manager'], <AdminPayments />)} />
        <Route path="users" element={withRoles(['admin', 'manager'], <AdminUsers />)} />
        <Route path="cohorts" element={withRoles(['admin', 'manager'], <AdminCohorts />)} />
        <Route path="departments" element={withRoles(['admin', 'manager'], <AdminDepartments />)} />
        <Route path="blogs" element={withRoles(['admin', 'manager'], <AdminBlogs />)} />
        <Route path="brochures" element={withRoles(['admin', 'manager'], <AdminBrochures />)} />
        <Route path="content" element={withRoles(['admin', 'manager'], <AdminContentManager />)} />
        <Route path="notifications" element={withRoles(['admin', 'manager'], <AdminNotifications />)} />
        <Route path="declarations" element={<Navigate to="/admin/student-declarations" replace />} />
        <Route path="student-declarations" element={withRoles(['admin', 'manager'], <AdminDeclarations key="student_request" mode="student_request" />)} />
        <Route path="administratie-verklaringen" element={<Navigate to="/admin/administrative-declarations" replace />} />
        <Route path="administrative-declarations" element={withRoles(['admin', 'manager'], <AdminDeclarations key="administrative" mode="administrative" />)} />
        <Route path="module-materials" element={withRoles(['admin', 'manager', 'instructor'], <AdminModuleMaterials />)} />
        <Route path="module-evaluations" element={withRoles(['admin', 'manager', 'instructor'], <AdminModuleEvaluations />)} />
        <Route path="exam-component-uploads" element={withRoles(['admin', 'manager', 'instructor'], <AdminExamComponentUploads />)} />
        <Route path="jaarlijkse-cijferlijst" element={<Navigate to="/admin/annual-grade-list" replace />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
